import ScalarIconEyeSlash_vue_vue_type_script_setup_true_lang_default from "./ScalarIconEyeSlash.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconEyeSlash.vue
var ScalarIconEyeSlash_default = ScalarIconEyeSlash_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconEyeSlash_default as default };

//# sourceMappingURL=ScalarIconEyeSlash.js.map